import angular from 'angular';
import featureName from './config/feature.js';
import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate.js';
import './element/index.js';

angular.module(featureName, [angularTranslate]).config(provideTranslations(featureName));
